export const serviceConstants = {
  OKTA_TOKEN_KEY: 'okta-token-storage'
};

export const errorConstants = {
  SERVER_ERROR: 'Failed to fetch data. Please try again.'
};
